module.exports = __webpack_public_path__ + "static/media/0.cd7ce1b7.png";